module.exports = __webpack_public_path__ + "img/Gentsestr na.b9efb52a.jpg";